export default "__VITE_ASSET__DDlXhIoE__"